<qai-inner-wrap>
  <div class="scenario-details" *ngIf="simulation">
    <div class="details-section">
      <div class="detail-item">
        <h2 class="detail-item-title">
          {{ "personalizedPractice.SCENARIO_DETAILS_TITLE" | transloco }}
        </h2>
        <p class="detail-item-description">
          {{ "personalizedPractice.SCENARIO_DETAILS_DESCRIPTION" | transloco }}
        </p>
      </div>

      <div class="inner">
        <!-- Avatar display -->
        <div class="avatar-image">
          <img
            *ngIf="!currentImageUrl"
            src="/assets/img/simulation-images/simulation-avatar.svg"
            [alt]="'personalizedPractice.AVATAR' | transloco"
          />

          <img
            *ngIf="currentImageUrl"
            [src]="currentImageUrl"
            [alt]="'personalizedPractice.AVATAR' | transloco"
          >
        </div>

        <div class="inner-right">
          <qai-item-grid
            [repeatCount]="'auto-fill'"
            [gap]="'24px'"
            [minItemWidth]="'280px'"
          >
            <qai-field
              [label]="'personalizedPractice.CONVERSATION_TYPE' | transloco"
            >
              <qai-floating-select
                [options]="activeSimulationOptions"
                [placeholder]="
                  'personalizedPractice.SELECT_CONVERSATION_TYPE' | transloco
                "
                [placement]="'below-start'"
                [offset]="4"
                [shape]="'rectangle'"
                [value]="selectedSimulationUuid"
                (selectionChange)="onActiveSimulationChange($event)"
              ></qai-floating-select>
            </qai-field>

            <qai-field
              *ngFor="let customizationType of customizationTypes"
              [label]="customizationType.typeName"
            >
              <qai-floating-select
                [options]="selectOptionsMap[customizationType.typeUuid] || []"
                [placeholder]="getSelectPlaceholder(customizationType)"
                [placement]="'below-start'"
                [offset]="4"
                [shape]="'rectangle'"
                [startIcon]="
                  customizationType.referenceType === tavusPersonaReferenceType
                    ? 'search'
                    : undefined
                "
                [value]="getSelectedValue(customizationType.typeUuid)"
                [disabled]="!selectedSimulationUuid"
                (selectionChange)="
                  onSelectionChange(customizationType.typeUuid, $event)
                "
              ></qai-floating-select>
            </qai-field>
          </qai-item-grid>
        </div>
      </div>
      <div class="detail-footer">
        <button
          qai-button
          kind="primary"
          size="large"
          [disabled]="!areAllRequiredOptionsSelected"
          (click)="launchSimulation()"
        >
          {{ "personalizedPractice.LAUNCH_SIMULATION" | transloco }}
        </button>
      </div>
    </div>
  </div>
</qai-inner-wrap>
